
import React, { ErrorInfo } from "react";

interface BoundaryProps {
    fallback: any
}

export class Boundary extends React.Component<BoundaryProps> {
    state = {
        error: null
    }

    static getDerivedStateFromError(error: Error) {
        // Update state so next render shows fallback UI.
        return { error: error };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        // Log the error to an error reporting service
    }

    render() {
        if (this.state.error) {
            // You can render any custom fallback UI
            return this.props.fallback;
        }

        return this.props.children;
    }
};
